import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-cream px-5 py-16 sm:py-20" data-id="element-108" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-xl text-center" data-id="element-109" data-mp="1o5q2iivokc11">
        <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-navy-light text-teal" data-id="element-110" data-mp="223ob17nble8m">
          <ShieldCheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-111" data-mp="1x5muatdd9r0b" />
        </span>
        <h2 className="mt-6 font-display text-xl font-black uppercase tracking-wide text-navy sm:text-2xl" data-id="element-112" data-mp="19dzeb6hn80ct">
          Notre garantie « Zéro Risque »
        </h2>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-navy/60" data-id="element-113" data-mp="1j4k72damyant">
          Essayez Mathématiques Prêtes™ pendant 30 jours. Utilisez-le en classe,
          imprimez les fiches. Si cela ne vous fait pas économiser des heures de
          stress, écrivez-nous : nous vous rembourserons chaque centime. Et vous
          pourrez garder les 5 Bonus en cadeau pour nous avoir fait confiance.
        </p>
        <a href="#faq" className="mt-5 inline-block text-xs font-bold text-teal underline underline-offset-4 transition-colors hover:text-teal-dark" data-id="element-114" data-mp="ozrsoo32f265">
          Lire les questions fréquentes
        </a>
      </div>
    </section>;
}